export const createLogService = (eventsService) => {
  let entries = [];
  let that = {};

  that.add = (entry) => {
    return new Promise((resolve) => {
      entries.push(entry);
      eventsService.emitEvent({ type: "log", data: entry });
      resolve();
    });
  };

  that.allEntries = () => entries;

  return that;
};
